import { AssetReport } from '../AssetReport';
import { AssetDetailsHeader } from './AssetDetailsHeader';
import { AssetSummary } from './AssetSummary';

const AssetDetails = () => {
  return (
    <>
      <AssetDetailsHeader />
      <AssetSummary>
        <AssetReport />
      </AssetSummary>
    </>
  );
};

export { AssetDetails };
